export default {
  'system.title': '系統需求',
  'system.required':
    '本服務支援<br />' +
    'iOS / iPadOS 14.1 以上作業系統<br />' +
    'Android 11 以上原生作業系統<br />' +
    '*內建客製化作業系統的裝置可能無法使用',
} as Record<string, string>;
